import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { SearchX } from 'lucide-react';
import { searchProducts } from '../mock/mock';
import ProductCard from '../components/ProductCard';

const SearchResults = () => {
  const [params] = useSearchParams();
  const q = params.get('q') || '';
  const results = searchProducts(q);

  return (
    <div className="max-w-7xl mx-auto px-6 py-12 min-h-[60vh]">
      <p className="font-oswald uppercase text-sm text-gray-400">Search results for</p>
      <h1 className="font-anton text-4xl ps-blue-text mb-8">“{q}”</h1>

      {results.length === 0 ? (
        <div className="flex flex-col items-center justify-center text-center py-20 text-gray-400">
          <SearchX size={56} className="mb-4 opacity-40" />
          <p className="font-oswald uppercase text-lg">No products found</p>
          <Link to="/products" className="mt-4 ps-blue-bg text-white px-6 py-3 rounded-full font-oswald uppercase text-sm btn-press">Browse all products</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 sm:gap-6">
          {results.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
};

export default SearchResults;
